// Словарь части 5.3 «Сдача и сверх договора»: закрытие этапов, итоговый акт, замечания клиента и доработка,
// допсоглашение из задач сверх договора, проект в сделке и у клиента. Подключается в `ru.ts` поверх словаря
// производства.

/** Сдача, документы проекта, проект в сделке и у клиента (ключи `projects.*`). */
export const ruProjectsDelivery = {
  delivery: {
    title: 'Сдать проект',
    closeTitle: 'Закрыть проект',
    actText:
      'Клиенту уйдёт итоговый акт на подпись: сначала подписывает студия, потом клиент — кодом из письма или сканом. Пока акт у клиента, проект «Сдаётся»',
    closeText: 'Проект закроется без акта и станет «Сдан».',
    closeReasons: {
      internal: 'Это внутренний проект студии — акт не нужен.',
      tm: 'Почасовой проект: часы к оплате считаются по месяцам, итоговый акт не собирается.',
      subscription: 'Подписка закрывается без акта.',
      no_order: 'У сделки нет подписанной заявки — акт собрать не к чему.',
      setting: 'Итоговый акт при сдаче выключен в настройках производства.',
    },
    total: 'Сумма договора',
    signed: 'Подписано актами',
    amount: 'Итоговый акт',
    zeroText: 'Подписанные акты уже закрывают всю сумму договора. Как сдать проект?',
    zeroEmpty: 'Акт без суммы',
    zeroEmptyHint: 'Клиент подпишет приёмку работ на 0 ₽',
    zeroNone: 'Без акта',
    zeroNoneHint: 'Проект сразу станет «Сдан»',
    stagesOpen: {
      one: 'Сначала закройте этапы: открыт {count}',
      few: 'Сначала закройте этапы: открыто {count}',
      many: 'Сначала закройте этапы: открыто {count}',
      other: 'Сначала закройте этапы: открыто {count}',
    },
    tasksOpen: {
      one: 'Сначала закройте задачи вне этапов: открыта {count}',
      few: 'Сначала закройте задачи вне этапов: открыто {count}',
      many: 'Сначала закройте задачи вне этапов: открыто {count}',
      other: 'Сначала закройте задачи вне этапов: открыто {count}',
    },
    pending: 'На подписи: «{title}» — дождитесь подписи или отзовите документ в сделке',
    submitAct: 'Отправить акт',
    submitClose: 'Закрыть проект',
    toastDelivered: 'Итоговый акт собран — подпишите его за студию',
    toastClosed: 'Проект «{title}» закрыт',
    reworkStage: 'Доработка',
    reworkTask: 'Замечания клиента',
    amendmentScope: 'Дополнительные работы по проекту «{project}»:',
    amendmentLine: '— {title} — {hours}',
    amendmentPrice:
      'Стоимость дополнительных работ — {price}. Сумма договора с учётом этого соглашения — {total}.',
  },
  documents: {
    title: 'Документы',
    order: 'Заявка № {number} от {date}',
    total: 'Сумма договора',
    remaining: 'Остаток по актам',
    acts: 'Акты',
    amendments: 'Допсоглашения',
    none: 'Пока нет',
    final: 'Итоговый',
    fromProject: 'Из задач проекта',
    noOrderTitle: 'Подписанной заявки нет',
    noOrderText: 'Договорные документы появятся, когда клиент подпишет заявку по сделке',
    noDealText: 'Проект заведён без сделки — договорных документов у него нет',
    toDeal: 'Счета и акты сделки',
    extraTitle: 'Сверх договора',
    extraEmpty: 'Задач сверх договора, не вошедших в допсоглашение, нет. Отметить задачу можно в её карточке',
    extraTotal: 'Итого {hours} · {price}',
    newTotal: 'Новая сумма договора — {total}',
    amend: 'Собрать допсоглашение',
    amended: 'Допсоглашение собрано — подпишите его за студию в сделке',
    priceProblems: 'Цену не посчитать: {problems}',
    problems: {
      no_policy: 'нет политики цены',
      no_tax: 'нет налога',
      no_rate: 'нет ставки специализации',
      no_tasks: 'нет задач',
      no_fixed_price: 'нет цены',
    },
    loadFailed: 'Документы не загрузились',
    invoices: 'Счета',
    schedule: 'График оплат',
    scheduleHint:
      'Доли оплаты из подписанной заявки. Доля «со стартом этапа» становится «Пора выставить счёт», когда закрыт предыдущий этап; «при запуске» — когда закрыты все этапы. Счёт выставляется здесь или в сделке — он сразу виден в «Финансах»',
    scheduleEmpty: 'В заявке нет графика оплат',
    readiness: {
      due: 'Пора выставить счёт',
      waiting: 'Ждёт этапа',
      waitingLaunch: 'Ждёт запуска',
      monthly: 'Каждый месяц',
      invoiced: 'Счёт выставлен',
    },
    whenStage: 'Со стартом этапа «{stage}»',
    issue: 'Выставить счёт',
    issueConfirm: 'Выставить счёт на {amount}?',
    issued: 'Счёт {number} выставлен — отправьте его клиенту из сделки',
    dueCount: {
      one: '{count} доля ждёт счёта',
      few: '{count} доли ждут счёта',
      many: '{count} долей ждут счёта',
      other: '{count} доли ждут счёта',
    },
  },
  stagesClose: {
    close: 'Закрыть этап',
    reopen: 'Переоткрыть этап',
    title: 'Закрыть этап «{title}»',
    openTasks: {
      one: 'В этапе {count} незакрытая задача. Что с ней сделать?',
      few: 'В этапе {count} незакрытые задачи. Что с ними сделать?',
      many: 'В этапе {count} незакрытых задач. Что с ними сделать?',
      other: 'В этапе {count} незакрытой задачи. Что с ними сделать?',
    },
    moveTo: 'Перенести в «{title}»',
    moveHint: 'Задачи продолжатся в следующем открытом этапе',
    moveNone: 'Перенести некуда: открытых этапов дальше нет',
    closeAsIs: 'Закрыть как есть',
    closeAsIsHint: 'Задачи станут «Готово», часы подтвердятся как записаны',
    submit: 'Закрыть этап',
    closed: 'Закрыт',
    toastClosed: 'Этап «{title}» закрыт',
    toastReopened: 'Этап «{title}» снова открыт',
  },
  pathDelivery: {
    closeStage: 'Закрыть этап «{title}»',
    deliver: 'Сдать проект',
    close: 'Закрыть проект',
    waiting: 'Когда все этапы закрыты — итоговый акт клиенту',
    waitingNoAct: 'Когда все этапы закрыты — проект закрывается без акта',
    delivering: 'Итоговый акт у клиента на подписи',
    doneOn: 'Сдан {date}',
    openDocuments: 'Документы проекта',
    extraPending: {
      one: '{count} задача сверх договора не согласована',
      few: '{count} задачи сверх договора не согласованы',
      many: '{count} задач сверх договора не согласованы',
      other: '{count} задачи сверх договора не согласованы',
    },
  },
  taskAmendment: {
    pending: 'Не согласовано с клиентом — допсоглашение на подписи',
    signed: 'Согласовано допсоглашением',
    notCovered: 'Ещё не в допсоглашении',
  },
  dealStep: {
    title: 'Проект',
    none: 'Проект появится, когда сделка будет выиграна',
    open: 'Открыть проект',
    stages: 'Этапы: {done} из {total}',
  },
  clientBlock: {
    title: 'Проекты и подписки',
    empty: 'Проектов пока нет — проект появится, когда клиент подпишет заявку',
  },
  settingsDelivery: {
    deliverAct: 'Итоговый акт при сдаче',
    deliverActHint:
      'Сдача проекта под ключ собирает итоговый акт к подписанной заявке. Выключите, если акты студия выставляет только по графику оплат',
  },
} as const;

/** Подсказки «i» 5.3 (в `projects.hints`). */
export const ruProjectsDeliveryHints = {
  finalAct: {
    title: 'Итоговый акт и остаток',
    text: 'Итоговый акт закрывает проект с клиентом: сумма договора (заявка с подписанными допсоглашениями) минус уже подписанные акты сделки. Строки — этапы, сумма делится по их плановым часам. Если остаток 0 — акт «без суммы» или закрыть без акта',
    example: 'Договор 450 000 ₽, подписан акт аванса на 200 000 ₽ — итоговый акт на 250 000 ₽',
  },
  stageClose: {
    title: 'Закрытие этапа',
    text: 'Этапы — внутренняя работа студии, клиент их не подписывает. Этап закрывает руководитель; незакрытые задачи можно перенести в следующий этап или закрыть как есть',
    example: 'Дизайн готов, правки шапки ещё идут — перенесите их в «Вёрстку»',
  },
  amendment: {
    title: 'Допсоглашение из задач',
    text: 'Задачи «Сверх договора», ещё не вошедшие в допсоглашение, собираются в одно допсоглашение. Цена — движком, как в смете: часы × плановая ставка → накладные → маржа → налог × коэффициенты сделки. Пока клиент не подписал, задачи «не согласованы»',
    example: 'Английская версия, 16 ч — допсоглашение на 48 000 ₽, сумма договора 498 000 ₽',
  },
} as const;

/** Уведомления 5.3 (в `projects.notifications`). */
export const ruProjectsDeliveryNotifications = {
  deliveredTitle: 'Проект «{title}» сдан клиенту',
  deliveredBody: 'Итоговый акт ушёл на подпись — сначала студия, потом клиент',
  finalSignedTitle: 'Клиент подписал итоговый акт по проекту «{title}»',
  finalSignedBody: 'Проект сдан',
  remarksTitle: 'Замечания клиента по проекту «{title}»',
  invoiceDueTitle: 'Пора выставить счёт · {amount}',
  invoiceDueStage: '{project}: начался этап «{stage}» — доля «{part}»',
  invoiceDueLaunch: '{project}: все этапы закрыты — доля «{part}» при запуске',
} as const;

/** Тексты ошибок `projects.*` части 5.3 (раздел 11 спецификации подпроекта 5). */
export const ruProjectsDeliveryErrors = {
  project_delivering: 'Проект у клиента на подписи — сначала отзовите итоговый акт',
  project_done: 'Проект сдан — этапы и сдачу больше не изменить',
  stage_done: 'Этап уже закрыт',
  stage_open: 'Этап и так открыт',
  stage_has_open_tasks:
    'В этапе есть незакрытые задачи — перенесите их в следующий этап или закройте как есть',
  no_next_stage: 'Дальше нет открытого этапа — закройте задачи как есть или добавьте этап',
  stages_open: 'Сначала закройте все этапы',
  tasks_open: 'Сначала закройте задачи вне этапов',
  documents_pending: 'У сделки документ на подписи: «{title}» — дождитесь подписи или отзовите его',
  zero_choice_required: 'Остаток по договору — 0: выберите акт без суммы или сдачу без акта',
  no_order: 'У проекта нет подписанной заявки — допсоглашение не к чему',
  extra_scope_empty: 'Нет задач сверх договора, которые ещё не вошли в допсоглашение',
  extra_scope_price_missing: 'Цену задач не посчитать: проверьте политику цены, налог и ставки специализаций',
  task_in_amendment: 'Задача уже в допсоглашении — отметку «Сверх договора» не снять, задачу не удалить',
} as const;

/** «История» проекта: этапы, сдача, допсоглашение. */
export const ruProjectsDeliveryAudit = {
  actions: {
    project: {
      stage_closed: 'Этап закрыт',
      stage_reopened: 'Этап переоткрыт',
      delivered: 'Проект сдан клиенту — итоговый акт на подписи',
      closed: 'Проект закрыт без акта',
      final_signed: 'Клиент подписал итоговый акт — проект сдан',
      remarks_received: 'Замечания клиента — этап доработки',
      delivery_revoked: 'Итоговый акт отозван — проект снова в работе',
      amendment_started: 'Собрано допсоглашение из задач сверх договора',
      amendment_signed: 'Допсоглашение подписано — задачи согласованы',
      amendment_declined: 'Допсоглашение не подписано — задачи снова сверх договора',
    },
  },
  fields: {
    movedTo: 'Перенесено в этап',
    closedAsIs: 'Закрыто как есть',
    remarks: 'Замечания',
  },
} as const;
